import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, X, Link2 } from "lucide-react";
import { Button } from "../ui/button";
import { api } from "../../lib/api";

export const ApprovalInbox = ({ isOwner }) => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.approvalsInbox().then((r) => setItems(r.items || [])).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const decide = async (it, ok, final = false) => {
    const reason = ok ? "" : window.prompt("سبب الرفض (اختياري)") ?? null;
    if (reason === null) return;
    try {
      const r = await api.approvalDecide(it.kind, it.id, ok, reason, final);
      toast.success(ok ? (r.done ? "تمت الموافقة النهائية ✅" : `تمت موافقتك — الطلب الحين عند ${r.next}`) : "تم رفض الطلب");
      load();
    } catch (e) { toast.error(e?.response?.data?.detail || "تعذّر تنفيذ الإجراء"); }
  };
  if (!items.length) return null;
  return (
    <div className="rounded-2xl border border-indigo-200 bg-indigo-50/40 p-4" data-testid="approval-inbox">
      <p className="mb-3 flex items-center gap-2 font-heading font-bold text-indigo-900"><Link2 className="h-5 w-5" /> طلبات بانتظار موافقتي ({items.length})</p>
      <div className="grid gap-2 md:grid-cols-2">
        {items.map((it) => (
          <div key={`${it.kind}-${it.id}`} className="rounded-xl border border-white bg-white p-3 text-sm shadow-sm" data-testid={`approval-item-${it.id}`}>
            <div className="flex items-center justify-between gap-2">
              <b className="text-slate-900">{it.kind_label} — {it.employee_name}</b>
              <span className="text-xs text-slate-400">{it.branch}</span>
            </div>
            <p className="mt-0.5 text-xs text-slate-600">{it.kind === "advance" || it.kind === "expense" ? `المبلغ ${it.amount ?? "—"} ر.س` : it.kind === "resignation" ? `آخر يوم عمل ${it.end_date || "—"}` : `${it.start_date} ← ${it.end_date}${it.days ? ` (${it.days} يوم)` : ""}`}{it.reason ? ` · ${it.reason}` : ""}</p>
            <div className="mt-2 flex flex-wrap items-center gap-1 text-[11px]">
              {it.steps.map((s, i) => <span key={i} className={`rounded-full px-2 py-0.5 ${i < it.step ? "bg-emerald-100 text-emerald-700" : i === it.step ? "bg-indigo-600 text-white" : "bg-slate-100 text-slate-500"}`}>{i + 1}. {s}</span>)}
            </div>
            {it.log?.length > 0 && <p className="mt-1 text-[11px] text-slate-500">{it.log.map((l) => `${l.role}: ${l.by}`).join(" · ")}</p>}
            <div className="mt-2 flex gap-2">
              <Button size="sm" onClick={() => decide(it, true)} className="h-8 gap-1 bg-emerald-600 hover:bg-emerald-700" data-testid={`approval-approve-${it.id}`}><Check className="h-4 w-4" /> موافقة{!it.mine ? " (كمالك)" : ""}</Button>
              {isOwner && it.step < it.steps.length - 1 && <Button size="sm" variant="outline" onClick={() => decide(it, true, true)} className="h-8 gap-1 border-emerald-300 text-emerald-700" data-testid={`approval-final-${it.id}`}><Check className="h-4 w-4" /> اعتماد نهائي</Button>}
              <Button size="sm" variant="outline" onClick={() => decide(it, false)} className="h-8 gap-1 text-rose-600" data-testid={`approval-reject-${it.id}`}><X className="h-4 w-4" /> رفض</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
